import { StateSchema } from 'app/config/storeConfig/types';
import { Box } from 'entities/Box';

export const getSelectedBox = (state: StateSchema): Nullable<Box> => state.createContractModal.selectedBox;
